import Navigation from './navigation.js';
import Tooltips from './tooltips.js';

import PageNav from './PageNav_rebuild.js';
//import smoothscroll from './smoothscroll.js';
//smoothscroll.polyfill();

import testimonialSlider from './testimonialSlider.js';

testimonialSlider();

Navigation();
Tooltips();
PageNav();

(()=>{

	let openedModalsCount = 0,
	mainNav = document.querySelector('.mainNav');

	[].forEach.call(document.querySelectorAll('.inner .modal'), ( modal ) =>{
		let wrapper = modal.querySelector('.modal>.modal-wrapper');

		modal.wrapper = wrapper;

		document.body.appendChild( wrapper );
	});



	[].forEach.call(document.querySelectorAll('.modal'), ( modal )=>{
		
		let 
		openButtons = [],
		openButtonsIds = [],
		wrapper = modal.wrapper ? modal.wrapper:modal.querySelector('.modal>.modal-wrapper'),
		content = wrapper.querySelector('.modal-wrapper>.modal-content'),
		closebtn = content.querySelector('.modal-content>.modal-close'),

		overlay = wrapper.querySelector('.modal-wrapper>.modal-overlay');
		
		if(wrapper.dataset.toggleid){
			openButtonsIds = wrapper.dataset.toggleid.split(',');
			openButtonsIds.forEach((id)=>{
				openButtons.push(document.getElementById(id));
			}
			);

		}else {
			openButtons.push(modal.querySelector('.modal>button'));
		}

		openButtons.forEach(
			 ( openButton ) => {

			 	if (openButton) {
					openButton.addEventListener('click', (e)=>{
						let scrollBarWidth = (window.innerWidth - document.documentElement.clientWidth);
						e.stopPropagation();
						e.preventDefault();
						mainNav.style.paddingRight = (scrollBarWidth/2)+'px';
						document.body.style.paddingRight = scrollBarWidth + 'px';
						wrapper.classList.add('modal-wrapper_visuallyHidden');

						setTimeout(
							()=>{
								wrapper.classList.add('modal-wrapper_modalOpen');
							},
							20
						);

						document.body.classList.add('modalOpen');
						openedModalsCount++;
					});
				}
			}
		);


		overlay.addEventListener('click', close);
		closebtn.addEventListener('click', close);

		function close (event) {
			
			
			wrapper.classList.remove('modal-wrapper_modalOpen');
			setTimeout(
				()=>{
					wrapper.classList.remove('modal-wrapper_visuallyHidden');
					openedModalsCount--;
					unlockBody();
				},
				250
			);
			

		}

		function unlockBody(){
			if( openedModalsCount == 0 ) {
				mainNav.style.paddingRight = '0px';
				document.body.style.paddingRight = '0px';
				wrapper.classList.remove('modal-wrapper_modalOpen');
				document.body.classList.remove('modalOpen');
			}
		}

	});
})();


(()=>{

   let wpcf7Elmnts = document.querySelectorAll( '.wpcf7' );

   [].forEach.call( wpcf7Elmnts, function(wpcf7Elm) {
   
   	wpcf7Elm.addEventListener( 'wpcf7invalid', errorHandler);
   	wpcf7Elm.addEventListener( 'wpcf7spam', errorHandler);
   	wpcf7Elm.addEventListener( 'wpcf7mailfailed', errorHandler);
   
    

      function errorHandler( event ) {

      	let errormessage = event.target.querySelector('.wpcf7-response-output');
      	errormessage.style.opacity = 1;

      	errormessage.addEventListener( 'click', hide );
         	setTimeout( hide, 3000 );

         	function hide () {
         		errormessage.style.opacity = 0;
         		setTimeout(()=>{
         			errormessage.style.display = 'none';
         			errormessage.style.opacity = 1;
         		},500);
         	}
      }
   });

})();

/*wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {

 let responseOutput = event.target.querySelector('.wpcf7-response-output');
	responseOutput.style.opacity = 1;

	responseOutput.addEventListener( 'click', hide );
   	setTimeout( hide, 3000 );



   	function hide () {
   		responseOutput.style.opacity = 0;
   		setTimeout(()=>{
   			responseOutput.style.display = 'none';
   			responseOutput.style.opacity = 1;
   		}, 500);
   	}
});*/

/*import PanelsSlider from './PanelsSlider.js';

[ ... document.getElementsByClassName('panelsSlider') ].forEach((el)=>{
	let slider = new PanelsSlider(el);
});
*/





/*let collapsible = document.querySelectorAll('.collapsible');

[].forEach.call(collapsible, function (el) {
	let title = el.querySelector('.collapsible-title');

	title.onclick = function(){
		
		el.classList.toggle('collapsed');
	}
});
*/

/*
function onPageNav () {
	let links = document.querySelectorAll('.stickyPageNav-link'),
	anchors = {},
	scrolling = false,
	scrollTimeout = null;

	if(!links.length){
		return;

	}

	[].forEach.call(links, (el)=>{
		let hash='#'+el.href.split("#")[1];
		anchors[hash] = el;
		el.onclick = ()=>{select(hash)};
	});
	
	function select(anchor) {
		[].forEach.call(links, (el)=>{
			el.classList.remove('stickyPageNav-link_active');
		});
		anchors[anchor].classList.add('stickyPageNav-link_active');
	}


	function scroll(){
		if(!scrolling){
			let currentAnchor = '#top'; 
			scrolling = true;
			scrollTimeout = setTimeout(() => {
				scrolling = false;
			}, 100);

			[].forEach.call(links, (link) => {
				
				let id = link.href.split('#')[1],
				linked = document.getElementById(id),
				bodyRect = document.body.getBoundingClientRect(),
				rect = linked.getBoundingClientRect();
				//console.log(rect.top - bodyRect.top < window.scrollY);
				if(rect.top - bodyRect.top -1 <  window.scrollY) {
					currentAnchor = '#' + id;
				}

			});
			
			select(currentAnchor);
		}
	}

	window.addEventListener('scroll', scroll.bind(this));


}

onPageNav();
*/